import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.Banco;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Componente para editar un Entity
*/
export class BancoFormNoRx extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {};
    }

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);

        return (
            <div>
                <kea.Title titulo="Banco" onRegresar={() => history.go("/catalogos/Banco")} />
                {kea.autogrid(6, [
                    <Text field="Nombre" />,
                    <Text field="NoCuenta" label="No. de cuenta" />,
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}

export const BancoForm = componentToRx(BancoFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/bancos/edit/form.tsx